import { hasPath } from "ramda";
import React from "react";

import { GridColumn } from "src/common/components/Grid";
import { ComplexFieldListRenderer } from "src/features/forms/components/ComplexFieldListRenderer";
import { FieldGroupListRenderer } from "src/features/forms/components/FieldGroupListRenderer";
import { FieldListRenderer } from "src/features/forms/components/FieldListRenderer";
import { FieldRenderer } from "src/features/forms/components/FieldRenderer";
import { FormContext } from "src/features/forms/context/FormContext";
import { NodeContext } from "src/features/forms/context/NodeContext";
import { ColumnData } from "src/features/forms/types";

export const ColumnRenderer: React.FunctionComponent<ColumnData> = React.memo(
	({ width, field }) => {
		const { value } = React.useContext(FormContext);
		const { path: rootPath } = React.useContext(NodeContext);
		const path = [...rootPath, ...field.path];
		if (path.length > 0 && !hasPath(path as string[], value)) {
			return null;
		}
		return (
			<GridColumn columnSize={width}>
				{field.type === "field-group-list" ? (
					<FieldGroupListRenderer {...field} />
				) : field.type === "field-list" ? (
					<FieldListRenderer {...field} />
				) : field.type === "complex-field-list" ? (
					<ComplexFieldListRenderer {...field} />
				) : (
					<FieldRenderer {...field} />
				)}
			</GridColumn>
		);
	}
);
